import { enableSpinner } from '@js/utilities/spinner';
import { productsListPromotion } from '@js/pages/category/productsListPromotion';
import { ProductsListPaginatorController } from '@js/pages/category/productsListPaginatorController';
import { mountProductBadges } from '../../../vue/helpers/badgesMount';

window.Badges = window.Badges || {
    labelsByProduct: {},
    promoByProduct: {},
};

const collectIds = (root = document) =>
    [...root.querySelectorAll('.product-badge-app')]
        .map((el) => JSON.parse(el.dataset.productId || 'null'))
        .filter(Boolean)
        .map(String);

const fetchBadges = async (ids = []) => {
    if (!ids.length) return;

    const query = ids.map((id) => `product_ids[]=${id}`).join('&');

    try {
        const [labelsRes, promoRes] = await Promise.all([
            fetch(`/api/products/labels?${query}`),
            fetch(`/api/promotions/products?${query}`),
        ]);

        if (!labelsRes.ok || !promoRes.ok) throw new Error('Bad response');

        window.Badges.labelsByProduct = await labelsRes.json();

        const promoJson = await promoRes.json();
        window.Badges.promoByProduct = Object.fromEntries(
            Object.entries(promoJson).map(([id, data]) => [
                id,
                data?.promotion_percent_values?.sum_percents_value ?? null,
            ])
        );
        window.dispatchEvent(new CustomEvent('badges.loaded'));
    } catch (e) {
        console.error('[Badges] fetch error:', e);
    }
};

window.fetchBadges = fetchBadges;
window.collectIds = collectIds;

const ProductsList = () => {
    const productsListContentContainer = document.querySelector(
        '.js-products-list-content-container'
    );

    ProductsListPaginatorController();
    productsListPromotion();
    fetchBadges(collectIds(productsListContentContainer));

    window.addEventListener('filters.filtering', () => {
        document.querySelectorAll('.js-filtering-show-spinner').forEach(enableSpinner);
    });

    window.addEventListener('filters.filtered', async (e) => {
        const html = await e.detail.productsListResponse.text();
        productsListContentContainer.innerHTML = html;

        productsListPromotion();
        fetchBadges(collectIds(productsListContentContainer));
        window.dispatchEvent(new Event('RemoteContentLoaded'));
        await mountProductBadges(document);
        const productsList = document.querySelector('.js-products-list');
        ProductsListPaginatorController();
        window.dispatchEvent(
            new CustomEvent('products-list-loaded', {
                detail: {
                    products_count: productsList.dataset.productsCount,
                    products_per_page: productsList.dataset.productsPerPage,
                    products_total_pages: productsList.dataset.productsTotalPages,
                    products_current_page: productsList.dataset.productsCurrentPage,
                },
            })
        );
    });
};

export default ProductsList;
